export default __webpack_public_path__ + "static/media/event_chat_mockup.129c3f35.svg";